import React from "react";
import { Trans, useTranslation } from "react-i18next";
import {
  FiShield, FiDatabase, FiCheckCircle, FiShare2, FiClock, FiUserCheck,
  FiUser, FiCreditCard, FiTag, FiRefreshCw, FiEdit3, FiInfo, FiLock,
  FiXCircle, FiAlertTriangle, FiHelpCircle,
} from "react-icons/fi";
import "./Privacy.css";

function Card({ icon, accent, title, children }) {
  return (
    <div className="privacy-card">
      <div className="privacy-card-head">
        <div className={`privacy-card-icon${accent ? ` privacy-card-icon--${accent}` : ""}`}>{icon}</div>
        <h3>{title}</h3>
      </div>
      <div className="privacy-card-body">{children}</div>
    </div>
  );
}

export default function Privacy() {
  const { t } = useTranslation('privacy');

  return (
    <div className="privacy-wrapper">
      <div className="privacy-hero">
        <h2>{t('heroTitle')}</h2>
        <p>{t('heroDesc')}</p>
        <div className="privacy-updated">{t('lastUpdated', { date: '03.11.2026' })}</div>
      </div>

      <div className="privacy-section-label">{t('sectionPrivacyPolicy')}</div>

      <Card icon={<FiShield size={16} />} title={t('card1Title')}>
        <p>
          <Trans t={t} i18nKey="card1Body">
            Playworld Sørlandet AS (org.nr. 927 789 086) er behandlingsansvarlig for
            personopplysningene som samles inn gjennom denne appen. Har du spørsmål om
            personvern, kontakt oss på <a href="mailto:post@playworld.no">post@playworld.no</a>{" "}
            eller <a href="tel:94467290">944 67 290</a>.
          </Trans>
        </p>
      </Card>

      <Card icon={<FiDatabase size={16} />} accent="orange" title={t('card2Title')}>
        <ul>
          {t('card2List', { returnObjects: true }).map((item, i) => <li key={i}>{item}</li>)}
        </ul>
        <p>{t('card2Note')}</p>
      </Card>

      <Card icon={<FiCheckCircle size={16} />} accent="purple" title={t('card3Title')}>
        <p>{t('card3Body')}</p>
      </Card>

      <Card icon={<FiInfo size={16} />} title={t('card4Title')}>
        <p>{t('card4Body')}</p>
      </Card>

      <Card icon={<FiShare2 size={16} />} accent="orange" title={t('card5Title')}>
        <p>{t('card5Intro')}</p>
        <ul>
          {t('card5List', { returnObjects: true }).map((item, i) => <li key={i}>{item}</li>)}
        </ul>
        <p>{t('card5Closing')}</p>
      </Card>

      <Card icon={<FiClock size={16} />} accent="purple" title={t('card6Title')}>
        <p>{t('card6Body')}</p>
      </Card>

      <Card icon={<FiLock size={16} />} title={t('card7Title')}>
        <p>{t('card7Body')}</p>
      </Card>

      <Card icon={<FiUserCheck size={16} />} accent="orange" title={t('card8Title')}>
        <p>{t('card8Intro')}</p>
        <ul>
          {t('card8List', { returnObjects: true }).map((item, i) => <li key={i}>{item}</li>)}
        </ul>
        <p>
          <Trans t={t} i18nKey="card8Closing">
            For andre personvernhenvendelser, kontakt <a href="mailto:post@playworld.no">post@playworld.no</a>.
          </Trans>
        </p>
      </Card>

      <div className="privacy-section-label">{t('sectionTermsOfUse')}</div>

      <Card icon={<FiUser size={16} />} title={t('card9Title')}>
        <p>{t('card9Body')}</p>
      </Card>

      <Card icon={<FiCreditCard size={16} />} accent="orange" title={t('card10Title')}>
        <p>{t('card10Body')}</p>
      </Card>

      <Card icon={<FiTag size={16} />} accent="purple" title={t('card11Title')}>
        <p>{t('card11Body')}</p>
      </Card>

      <Card icon={<FiXCircle size={16} />} title={t('card12Title')}>
        <p>{t('card12Body')}</p>
      </Card>

      <Card icon={<FiAlertTriangle size={16} />} accent="orange" title={t('card13Title')}>
        <p>
          <Trans t={t} i18nKey="card13Body">
            Opplever du feil eller mangler ved et kjøp, gi oss beskjed på{" "}
            <a href="mailto:post@playworld.no">post@playworld.no</a> så snart som mulig. Fører
            ikke dette frem, kan du kontakte{" "}
            <a href="https://www.forbrukertilsynet.no" target="_blank" rel="noreferrer">Forbrukertilsynet</a>{" "}
            (<a href="tel:23400600">23 400 600</a>), eller EU-kommisjonens{" "}
            <a href="https://ec.europa.eu/odr" target="_blank" rel="noreferrer">klageportal</a>{" "}
            hvis du bor i et annet EU/EØS-land.
          </Trans>
        </p>
      </Card>

      <Card icon={<FiRefreshCw size={16} />} accent="purple" title={t('card14Title')}>
        <p>
          <Trans t={t} i18nKey="card14Body">
            Ved feilkjøp eller andre henvendelser om refusjon, ta kontakt med oss på{" "}
            <a href="mailto:post@playworld.no">post@playworld.no</a>, så gjør vi en vurdering av
            refusjon i det enkelte tilfellet.
          </Trans>
        </p>
      </Card>

      <Card icon={<FiEdit3 size={16} />} title={t('card15Title')}>
        <p>{t('card15Body')}</p>
      </Card>

      <Card icon={<FiHelpCircle size={16} />} accent="orange" title={t('card16Title')}>
        <p>
          <Trans t={t} i18nKey="card16Body">
            Ta kontakt med oss på <a href="mailto:post@playworld.no">post@playworld.no</a> om det
            er noe du lurer på, eller om du ikke finner det du leter etter :)
          </Trans>
        </p>
      </Card>
    </div>
  );
}
